export const handleKeyPress = (event, onClickFunction) => {
    if (event.key === 'Enter' || event.key === 'Space') {
      onClickFunction();
    }
  };